import type { JobListItemFragment } from 'src/graphql/__generated__';

import { PayPerPlacementButton } from './PayPerPlacementButton';
import { UpgradeButton } from './UpgradeButton/UpgradeButton';

interface JobUpgradesProps {
  job: JobListItemFragment;
}

export const JobUpgrades: React.FC<
  React.PropsWithChildren<JobUpgradesProps>
> = ({ job }) => {
  switch (true) {
    case job.canBeUpgraded:
      return <UpgradeButton job={job} />;
    case job.payPerPlacementEligibility.__typename ===
      'PayPerPlacementEligibleResponse':
      return (
        <PayPerPlacementButton
          jobId={job.id}
          {...job.payPerPlacementEligibility}
        />
      );
  }
  return null;
};
